import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@sparro/core/guards/auth/auth.guard';

import { JournalEditComponent } from './journal-edit/journal-edit.component';
import { JournalEditRouterComponent } from './journal-edit-router/journal-edit-router.component';
import { RedirectCheckComponent } from './redirect-check/redirect-check.component';
import { JournalMetaComponent } from './journal-meta/journal-meta.component';

const routes: Routes = [
  {
    path: '',
    component: RedirectCheckComponent,
    canActivate: [AuthGuard],
    data: { service: 'journals'}
  },
  {
    path: ':uuid',
    component: JournalEditRouterComponent,
    canActivate: [AuthGuard],
    data: { service: 'journals'},
    children: [
      {
        path: '',
        component: JournalEditComponent,
        canActivate: [AuthGuard],
        data: { service: 'journals'}
      },
      {
        path: 'meta',
        component: JournalMetaComponent,
        canActivate: [AuthGuard],
        data: { service: 'journals'}
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JournalEditRoutingModule { }
